/**
 * Números pt-BR que não são dinheiro nem percentual — as notas e pesos de
 * Compliance (`19,4`, `0,2`, `Sim · 3,0`) e o tamanho de um arquivo (`2,4 MB`).
 */

/** `19,4` · `3,0` · `0` — uma casa fixa, exceto o zero, que o shot `3a` desenha seco. */
export function formatarDecimal(valor: number, casas = 1): string {
  if (valor === 0) return '0'
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  }).format(valor)
}

/** `840 KB` · `2,4 MB` — base 1024, como o sistema operacional mostra. */
export function formatarTamanhoDeArquivo(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`
  return `${formatarDecimal(bytes / (1024 * 1024))} MB`
}
